import { Box } from '@bonusly/design-system';

import type { BizyMarkdownNode } from '../../../../lib/bizy/types/nodes';
import { useBizyChatActions } from '../context/actions-context';
import { BizyStreamingMessage } from '../lib/streaming-message';
import type { BizyNodeProps } from './node-props';

/**
 * Renders a `markdown` node via Streamdown. Only the active (last) markdown
 * node receives live streaming UI (tool progress / thinking phrase / pulsing
 * cursor); earlier markdown nodes were closed by an intervening card and render
 * as finalized segments even mid-stream.
 */
export function MarkdownNode({ node, isActiveMarkdown, isLastNode }: BizyNodeProps) {
	const { payload } = node as BizyMarkdownNode;
	const { fontSize, isComplete, toolProgress, thinkingPhrase, onContentUpdate, onSuggestedPageClick } = useBizyChatActions();
	const isWorkingPlan = payload.role === 'working_plan';

	return (
		<Box mb={isLastNode ? 0 : 4}>
			<BizyStreamingMessage
				content={payload.content}
				fontSize={fontSize}
				isComplete={isComplete || !isActiveMarkdown}
				onContentUpdate={onContentUpdate}
				toolProgress={isActiveMarkdown ? toolProgress : undefined}
				thinkingPhrase={isActiveMarkdown ? thinkingPhrase : undefined}
				progressPlacement={isWorkingPlan ? 'below' : 'above'}
				onSuggestedPageClick={onSuggestedPageClick}
			/>
		</Box>
	);
}
